'use client';

import {mediaFromWire, type MediaBannerWireSection} from '../../model';
import {SectionMedia} from './SectionMedia';

const BANNER_ASPECT = '16 / 9';
const BANNER_SECTION_NAME = 'banner';

export interface AboutMediaBannerSectionProps {
  mediaBanner: MediaBannerWireSection['mediaBanner'];
  sectionId?: string;
}

export function AboutMediaBannerSection({mediaBanner, sectionId}: AboutMediaBannerSectionProps) {
  const media = mediaFromWire(mediaBanner?.webMedia ?? mediaBanner?.mobileMedia);
  if (!media) {
    return null;
  }
  return (
    <SectionMedia
      media={media}
      alt={media.alt ?? ''}
      aspectRatio={BANNER_ASPECT}
      fullBleed
      sectionName={BANNER_SECTION_NAME}
      sectionId={sectionId}
    />
  );
}

AboutMediaBannerSection.displayName = 'AboutMediaBannerSection';
